import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useRatingInsight = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [ratingInsightData, setRatingInsightData] = useState<any[]>([]);

    const onRatingDataError = (err: AxiosError<ErrorHttpResponse>) => {
        setRatingInsightData([]);
    };

    const onRatingDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<RatingDataSuccessInterface[]>) => {
        setRatingInsightData(Array.isArray(data) ? data : []);
    };

    const getRatingDataInsight = (urlString: string, companyId: string) => {
        const separator = urlString.includes('?')
            ? (urlString.endsWith('?') || urlString.endsWith('&') ? '' : '&')
            : '?';

        const url: HttpConfig = {
            url: `${urlString}${separator}companyId=${encodeURIComponent(companyId)}`,
            method: 'get',

        };
        request(url, onRatingDataSuccess, setLoading, onRatingDataError);
    };

    return { getRatingDataInsight, loading, ratingInsightData };
};

export default useRatingInsight;


export interface RatingDataSuccessInterface {
    dayLabel: string;
    day: string;
    averageRating: number;
    ratingClass: string;
    noOfRatings: number;
    ratingColor: any;
}
